import { render, staticRenderFns } from "./PartnerTanimla.vue?vue&type=template&id=6a5b668b&scoped=true&"
import script from "./PartnerTanimla.vue?vue&type=script&lang=js&"
export * from "./PartnerTanimla.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTanimla.vue?vue&type=style&index=0&id=6a5b668b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b668b",
  null
  
)

export default component.exports